import * as React from 'react';
import Button from '@mui/material/Button';
import { useReportOutage } from '@/hooks/api/useOutages';
import { useNotification } from '@/contexts/NotificationContext';
import OutageFormModal from '@/components/outage/OutageFormModal';

interface ReportOutageActionButtonProps {
  type: 'trk' | 'atm' | 'goa',
  assetId: string
}

function ReportOutageActionButton({
  type,
  assetId
}: ReportOutageActionButtonProps) {

  const [reportOutageVisible, setReportOutageVisible] = React.useState(false);
  const reportOutageMutation = useReportOutage();
  const { showSuccess, showError } = useNotification();

  const submitOutage = (values: any) => {
    reportOutageMutation.mutate(
      { ...values, type, assetId },
      {
        onSuccess: () => {
          setReportOutageVisible(false);
          showSuccess("Report created");
        },
        onError: (error: any) => {
          showError(error.message || "Failed to create report");
        },
      }
    );
  }

  return (
    <>
      <Button onClick={() => setReportOutageVisible(true)} color="secondary" variant="contained" sx={{ textTransform: 'none' }}>
        Report {type.toUpperCase()} Outage
      </Button>

      <OutageFormModal
        visible={reportOutageVisible}
        onDismiss={() => setReportOutageVisible(false)}
        onSubmit={submitOutage}
        initialValues={{
          outageDate: new Date(),
          outageReason: '',
          resolution: '',
          resolveDate: ''
        }}
        title={`Report ${type.toUpperCase()} Outage`}
        />
    </>
  );
}
export default ReportOutageActionButton;
